import { render, staticRenderFns } from "./PaginatedSingleSelect.vue?vue&type=template&id=19b55542&scoped=true&"
import script from "./PaginatedSingleSelect.vue?vue&type=script&lang=ts&"
export * from "./PaginatedSingleSelect.vue?vue&type=script&lang=ts&"
import style0 from "./PaginatedSingleSelect.vue?vue&type=style&index=0&id=19b55542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b55542",
  null
  
)

/* custom blocks */
import block0 from "./PaginatedSingleSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports